import { RippleFormButton } from "@/forms-design-system/FormButton";
import { useTranslate } from "@/hooks/useTranslate";

export type ThemedAddMembershipButtonProps = {
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

export const ThemedAddMembershipButton = ({ onClick }: ThemedAddMembershipButtonProps) => {
  const { t } = useTranslate();

  return (
    <RippleFormButton
      sx={{
        minWidth: { xs: 0, md: 140 },
      }}
      onClick={onClick}
      data-test="themed-add-membership-button"
    >
      {t("ticketing", "select")}
    </RippleFormButton>
  );
};
